module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio-span",
    class: [_vm.is_full, _vm.is_survey]
  }, [_c('span', [_c('radio', {
    attrs: {
      "correct": _vm.correct,
      "caption": _vm.caption,
      "group": _vm.group,
      "title": _vm.title,
      "groupQuestion": _vm.groupQuestion
    }
  })], 1), _vm._v(" "), (_vm.is_strong) ? _c('p', [_c('strong', [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")])]) : _c('p', [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c5934b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/radio_span.vue
// module id = 639
// module chunks = 1